import { IPost } from "@eagerdog/interfaces";

import { toast } from "src/components/Toast/ToastManager";

/**
 * Shared toasts for the post composers (photo, run share, club update).
 * See data/prd/CONTENT_MODERATION_PRD.md — a screening hold is reported as
 * success-with-a-note, never as an error.
 */
export const notifyPostCreated = (post?: IPost | null): void => {
    if (post?.moderation_status === "under_review") {
        toast.show({
            title: "Posted",
            content: "We're giving this one a quick look before it appears to others.",
            duration: 8000,
            type: "success",
        });
    }
};

/**
 * Surface a posting-suspension 403 with the server's message; anything else
 * falls back to the composer's generic failure copy.
 */
export const showPostError = (err: any, fallback: { title: string; content: string }): void => {
    const status = err?.response?.status;
    const message = err?.response?.data?.message;
    if (status === 403 && typeof message === "string" && /paused/i.test(message)) {
        toast.show({ title: "Posting is paused", content: message, duration: 10000, type: "fail" });
        return;
    }
    toast.show({ ...fallback, duration: 8000, type: "fail" });
};
